import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { ListOption } from '../modules/tcm-core.module';
import { ListOptionRequest } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class AppointmentTypeDataService {
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getAppointmentTypeOptionsAsync(query: string, cancellationToken: Promise<any>): Promise<ListOption<number>[]> {
    const request: ListOptionRequest = { searchString: query };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('AppointmentTypes/Options', request, cancellationToken);
  } 

  public getGetMarketingCampaignRequiredAsync(appointmentTypeId: number, cancellationToken: Promise<any>): Promise<boolean> {
    const request = { appointmentTypeId: appointmentTypeId };
    return this.httpClient.getJsonAsync<boolean>('AppointmentTypes/GetMarketingCampaignRequired', request, cancellationToken);
  } 
}
